export function createTrackBy<T>(key: keyof T): (number, T) => T[keyof T] {
  return (_: number, item: T): T[keyof T] => {
    return item[key];
  };
}
